import { useQuery, type UseQueryOptions } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';
import ApiClient from '@/plugins/store/actions/api/ApiClient';
import type { WeekOverviewResponse } from '@/types';

export const queryKeys = {
    getWeekDataRoot: ['week-overview', 'week-data'],
    getWeekData: (farmId: Ref<number | null>, isWeaner: Ref<boolean>) => [...queryKeys.getWeekDataRoot, farmId, isWeaner],
};

// Fetches every insertion cohort for one farm+animal-type - the whole farm history in one call,
// same window RunTrace already computes, no date-range param (KS-1699: filtering to a selected
// period happens client-side over this full list, since a cohort's own life-cycle data is never
// clipped at the range's end date). Computed on-the-fly by Analytics-v2, so this can be slow
// (a troubleshooting tool, not a page hit continuously) - the caller is expected to show a
// loading state for as long as it takes rather than time out.
export function useWeekOverviewData(farmId: Ref<number | null>, isWeaner: Ref<boolean>, options: UseQueryOptions<WeekOverviewResponse> = {}) {
    return useQuery<WeekOverviewResponse>({
        queryKey: queryKeys.getWeekData(farmId, isWeaner),
        queryFn: () => ApiClient.send('get', `weekoverview?farmId=${farmId.value}&isWeaner=${isWeaner.value}`, {}),
        enabled: computed(() => farmId.value !== null),
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10,
        retry: false,
        ...options,
    });
}
